import React from "react";

const NutritionSection = ({ nutritionData, setIsMealLogOpen, pageName }) => {
  const currentDate = new Date();
  const tdate =
    currentDate.getDate() +
    " " +
    currentDate.toLocaleString("default", { month: "short" }) +
    " " +
    currentDate.getFullYear();

  if (nutritionData) {
    let calorieIntake =
      nutritionData?.calorie?.toFixed(1) ||
      nutritionData?.dailylodReport?.calorie?.toFixed(1) ||
      0;
    let calorie_burned =
      nutritionData?.calorie_burned?.toFixed(1) ||
      nutritionData?.dailylodReport?.calorie_burned?.toFixed(1) ||
      0;
    let calorie_burned_recomended =
      nutritionData?.RecommendedCalorie?.toFixed(1) ||
      nutritionData?.dailylodReport?.RecommendedCalorie?.toFixed(1) ||
      0;
    let carbsIntake =
      nutritionData?.nutrientsCarbs?.toFixed(1) ||
      nutritionData?.dailylodReport?.nutrientsCarbs?.toFixed(1) ||
      0;
    let proteinIntake =
      nutritionData?.nutrientsProtein?.toFixed(1) ||
      nutritionData?.dailylodReport?.nutrientsProtein?.toFixed(1) ||
      0;
    let fatValue =
      nutritionData?.nutrientsFat?.toFixed(1) ||
      nutritionData?.dailylodReport?.nutrientsFat?.toFixed(1) ||
      0;
    let lastlogged = calorieIntake != 0 ? true : false;

    return (
      <div className="sm:w-full md:w-full w-full">
        <div className="">
          <div className="tabroe">
            <div className="modetit text-lg">Nutrition intake</div>
            <div className="modesutit text-[11px]">Today, {tdate}</div>
          </div>
        </div>
        <div className="fastiweekbox">
          <div className="fasweekdes">
            <div className="mode1">
              <img
                loading="lazy"
                src="../images/deshboard/kcal.webp"
                alt="mode"
              />
              <div className="tabroe">
                <div className="modetit">Calories</div>
                <div className="modesutit">
                  {lastlogged ? "Last logged at" : "Not logged yet"}{" "}
                  {lastlogged ? tdate : ""}
                </div>
              </div>
            </div>
            {setIsMealLogOpen ? (
              <>
                <div
                  className="plusbox cursor-pointer"
                  onClick={() => {
                    setIsMealLogOpen(true);
                  }}
                >
                  <img
                    loading="lazy"
                    src="../images/deshboard/pluse.webp"
                    alt="pluse"
                  />
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
          <div>
            <hr />
          </div>
          <div className="fasweekdes">
            <div className="mode1">
              <div className="tabroe">
                <div className="modesutit">Intake</div>
                <div className="tabetsbol">{calorieIntake} cal</div>
              </div>
              <div className="tabroe">
                <div className="modesutit">
                  {calorie_burned ? "Burned" : "Required"}
                </div>
                <div className="tabetsbol">{calorie_burned} cal</div>
              </div>
            </div>

            {calorie_burned_recomended != 0 && (
              <div className="tabroe">
                <div className="modesutit">
                  {calorie_burned ? "Remaining" : "Recomended"}
                </div>
                <div className="tabetsbol">{calorie_burned_recomended} cal</div>
              </div>
            )}
          </div>

          <div className="desbar ">
            <div className="desbarnotfil">
              <div className={`desbarfil  w-[0%]`}></div>
            </div>
          </div>
        </div>

        {nutritionData ? (
          <div className="grid grid-cols-3 spacetop gap-2 ">
            <div className="nutbotmbox w-full">
              <div className="nutbotmbox1">
                <div className="nutbotmbox1tex">
                  <p>carbs</p>
                </div>
              </div>
              <div className="tabroe1">
                <div className="nutbotmtex mb-2">
                  <p>{carbsIntake}</p>
                </div>
                <div className="modesutit1 max-[767px]:-mt-[10%]">
                  <p>gm</p>
                </div>
                <div className="nutbarnotfill">
                  <div className={`nutbarfill  w-[0%]`} />
                </div>
              </div>
            </div>
            <div
              className="nutbotmbox w-full"
              style={{
                border: "2px solid rgba(88, 85, 158, 0.30)",
              }}
            >
              <div
                className="nutbotmbox1"
                style={{
                  background: "rgba(88, 85, 158, 0.10)",
                }}
              >
                <div className="nutbotmbox1tex" style={{ color: "#58559E" }}>
                  <p>proteins</p>
                </div>
              </div>
              <div className="tabroe1">
                <div className="nutbotmtex mb-2">
                  <p>{proteinIntake}</p>
                </div>
                <div className="modesutit1 max-[767px]:-mt-[10%]">
                  <p>gm</p>
                </div>
                <div className="nutbarnotfill">
                  <div className={`nutbarfill bg-[#58559E] w-[0%]`} />
                </div>
              </div>
            </div>
            <div
              className="nutbotmbox w-full"
              style={{
                border: "2px solid rgba(255, 153, 80, 0.30)",
              }}
            >
              <div
                className="nutbotmbox1"
                style={{
                  background: "rgba(255, 153, 80, 0.10)",
                }}
              >
                <div className="nutbotmbox1tex" style={{ color: "#FF9950" }}>
                  <p>fats</p>
                </div>
              </div>
              <div className="tabroe1">
                <div className="nutbotmtex mb-2">
                  <p>{fatValue}</p>
                </div>
                <div className="modesutit1 max-[767px]:-mt-[10%]">
                  <p>gm</p>
                </div>
                <div className="nutbarnotfill">
                  <div className={`nutbarfill bg-[#FF9950] w-[0%]`} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
};

export default React.memo(NutritionSection);
